import { render, staticRenderFns } from "./TaskMessages.vue?vue&type=template&id=7b268aa7&scoped=true&"
import script from "./TaskMessages.vue?vue&type=script&lang=js&"
export * from "./TaskMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b268aa7",
  null
  
)

export default component.exports